"use strict";

[...document.getElementsByTagName("details")].forEach((D, _, A) =>
  D.addEventListener(
    "toggle",
    (E) => D.open && A.forEach((d) => d != E.target && (d.open = false))
  )
);
